import { Entity, Field } from 'typegraph';

import { IEntry } from 'common/entities/courseWrapper/CourseWrapper';
import LaunchURL from 'common/entities/LaunchURL';
import Product from './Product';
import Subscription from './Subscription';

@Entity({one: "recommendedEntries", many: "recommendedEntries"})
export default class Entry implements IEntry {

	@Field()
	public id: string;

	@Field()
	public displayName: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field({entity: Product})
	public product: Product;

	@Field({entity: Subscription})
	public subscription: Subscription;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;
}



// WEBPACK FOOTER //
// ./src/panels/recommended/entities/Entry.ts